(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["clean-break"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const dialog = root.querySelector('.cb-dialog');
      const carousel = root.querySelector('.cb-carousel');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let timer;
      const remember = () => {
        try {
          sessionStorage.setItem('cb-signup-seen', 'true');
        } catch (_) {}
      };
      const openDialog = () => {
        clearTimeout(timer);
        if (!dialog.open) dialog.showModal();
        remember();
      };
      const closeDialog = () => dialog.close();
      root.querySelectorAll('[data-open-signup]').forEach((link) =>
        link.addEventListener('click', (event) => {
          if (typeof dialog.showModal !== 'function') return;
          event.preventDefault();
          openDialog();
        }),
      );
      root.querySelector('[data-close-dialog]').addEventListener('click', closeDialog);
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) {
          const rect = dialog.getBoundingClientRect();
          if (
            event.clientX < rect.left ||
            event.clientX > rect.right ||
            event.clientY < rect.top ||
            event.clientY > rect.bottom
          )
            closeDialog();
        }
      });
      dialog.addEventListener('close', remember);
      const buttons = root.querySelectorAll('[data-slide]');
      const updateCarousel = () =>
        buttons.forEach((button) => {
          button.disabled =
            Number(button.dataset.slide) < 0
              ? carousel.scrollLeft <= 2
              : carousel.scrollLeft + carousel.clientWidth >= carousel.scrollWidth - 2;
        });
      buttons.forEach((button) =>
        button.addEventListener('click', () =>
          carousel.scrollBy({
            left: (carousel.firstElementChild.getBoundingClientRect().width + 16) * Number(button.dataset.slide),
            behavior: reducedMotion.matches ? 'instant' : 'smooth',
          }),
        ),
      );
      carousel.addEventListener('scroll', updateCarousel, { passive: true });
      const resize = new ResizeObserver(updateCarousel);
      resize.observe(carousel);
      updateCarousel();
      const modalFeedback = dialog.querySelector('.cb-form-success, .cb-form-error');
      if (modalFeedback && location.hash.includes('CBModal-')) {
        openDialog();
        modalFeedback.setAttribute('tabindex', '-1');
        modalFeedback.focus();
      }
      const success = root.querySelector('.cb-form-success');
      if (success) remember();
      let seen = false;
      try {
        seen = sessionStorage.getItem('cb-signup-seen') === 'true';
      } catch (_) {
        seen = true;
      }
      if (
        root.dataset.popup === 'true' &&
        !seen &&
        !success &&
        !window.Shopify?.designMode &&
        typeof dialog.showModal === 'function'
      ) {
        timer = setTimeout(() => {
          if (
            document.hidden ||
            root.contains(document.activeElement) ||
            root.querySelector('.cb-form input[type="email"]:valid:not(:placeholder-shown)')
          )
            return;
          openDialog();
        }, 30000);
      }
      document.addEventListener(
        'shopify:section:unload',
        (event) => {
          if (event.target.contains(root)) {
            clearTimeout(timer);
            resize.disconnect();
          }
        },
        { once: true },
      );
    };
    document.querySelectorAll('[data-clean-break]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) =>
      event.target.querySelectorAll('[data-clean-break]').forEach(initialize),
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
